import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Box, HeadingStyled, LabelStyled } from "../../../Styled/Elements";
import { useTranslation } from "react-i18next";
import {
  ButtonCustom,
  InputStyled,
  SecondaryInputStyled,
  SecondaryTextAreaStyled,
  SelectionDropdown,
} from "../../../Styled/CustomElements";
import { Col, Form, Row } from "react-bootstrap";
import styled from "styled-components";
import { Cancel } from "../../../Styled/AllImages";
import { Controller, useForm } from "react-hook-form";
import PhoneInputField from "../../../Styled/inputFields/PhoneInput";
import ValidationErrorText from "../../../Styled/inputFields/ValidationErrorText";
import axios from "axios";
import { toast } from "react-toastify";
import {
  companySizeOptions,
  roleOptions,
  salesHelpOptions,
} from "../../../../utils/contants";

function CustomModal({ show, setShow, title }) {
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const localizedRoleOptions = roleOptions.map((opt) => ({
    label: t(opt.label),
    value: t(opt.label), // same as label
  }));

  const localizedCompanySizeOptions = companySizeOptions.map((opt) => ({
    label: t(opt.label),
    value: t(opt.label),
  }));

  const localizedSalesHelpOptions = salesHelpOptions.map((opt) => ({
    label: t(opt.label),
    value: t(opt.label),
  }));
  const handleClose = () => setShow(false);

  const fetchCountries = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/countries-list`
      );
      if (data.status) {
        const countryOptions = data?.data?.map((country) => ({
          value: country.id,
          label: `${language === "ar" ? country.ar_name : country.en_name} ${
            country.emoji
          }`,
        }));
        setCountries(countryOptions);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchCountries();
  }, [language]);

  const onSubmit = async (formData) => {
    try {
      setLoading(true);
      const { data } = await axios.post(
        `${API_URL}/contact/sales-team`,
        formData
      );
      if (data?.code === 200) {
        toast.success(data?.message);
        reset();
        handleClose();
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const countryOptions = [
    { label: "Option 1", value: "1" },
    { label: "Option 2", value: "2" },
    { label: "Option 3", value: "3" },
  ];

  return (
    <ModalWrapper>
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header className="contact-modal-heading justify-content-between px-lg-4 px-md-3 px-2">
          <HeadingStyled size="24px" weight="bold" color="var(--text)">
            {title}
          </HeadingStyled>
          <Box>
            <Cancel onClick={handleClose} style={{ cursor: "pointer" }} />
          </Box>
        </Modal.Header>

        <Form onSubmit={(e) => e.preventDefault()} noValidate>
          <Modal.Body className="px-lg-4 px-md-3 px-2">
            <Box>
              <Row>
                <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("first_name")}*
                    </LabelStyled>
                    <SecondaryInputStyled
                      {...register("first_name", { required: true })}
                      placeholder={t("namePlaceholder")}
                      border="var(--border)"
                    />
                    {errors.first_name && (
                      <ValidationErrorText
                        text={`${t("first_name")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col>

                <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("last_name")}*
                    </LabelStyled>
                    <SecondaryInputStyled
                      {...register("last_name", { required: true })}
                      placeholder={t("namePlaceholder")}
                      border="var(--border)"
                    />
                    {errors.last_name && (
                      <ValidationErrorText
                        text={`${t("last_name")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col>

                <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("work_email")}*
                    </LabelStyled>
                    <SecondaryInputStyled
                      {...register("email", {
                        required: true,
                        pattern: /^\S+@\S+$/i,
                      })}
                      placeholder={t("work_email")}
                      border="var(--border)"
                    />
                    {errors.email && (
                      <ValidationErrorText
                        text={`${t("work_email")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col>

                {/* <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("role")}*
                    </LabelStyled>
                    <SecondaryInputStyled
                      {...register("role", { required: true })}
                      placeholder={t("role")}
                      border="var(--border)"
                    />
                    {errors.role && (
                      <ValidationErrorText
                        text={`${t("role")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col> */}
                <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("role")}*
                    </LabelStyled>
                    <SelectionDropdown
                      name={"role"}
                      value={watch("role")}
                      register={register}
                      errors={errors}
                      validationRules={{
                        required: true,
                      }}
                      options={localizedRoleOptions}
                      placeholder={t("select_one")}
                      border="var(--border)"
                    />
                    {errors.role && (
                      <ValidationErrorText
                        text={`${t("role")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col>

                <Col lg={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("country_region")}*
                    </LabelStyled>
                    <SelectionDropdown
                      name={"country"}
                      value={watch("country")}
                      register={register}
                      errors={errors}
                      validationRules={{
                        required: true,
                      }}
                      options={countries}
                      placeholder={t("select_one")}
                      className="countryDropdown"
                      border="var(--border)"
                    />
                    {/* <Controller
                      name="country"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <SelectionDropdown
                          {...field}
                          options={countries}
                          placeholder={t("select_one")}
                          border="var(--border)"
                          onChange={(selected) =>{
                            console.log(selected.value);
                            
                            field.onChange(selected.value)}
                          } // Ensure value gets passed
                          value={
                            countries.find((c) => c.value == field.value) ||
                            null
                          }
                        />
                      )}
                    /> */}
                    {errors.country && (
                      <ValidationErrorText
                        text={`${t("country_region")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col>

                <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("company")}*
                    </LabelStyled>
                    <SecondaryInputStyled
                      {...register("company", { required: true })}
                      placeholder={t("companyPlaceholder")}
                      border="var(--border)"
                    />
                    {errors.company && (
                      <ValidationErrorText
                        text={`${t("company")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col>

                {/* <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("company_size")}*
                    </LabelStyled>
                    <SecondaryInputStyled
                      {...register("company_size", { required: true })}
                      placeholder={t("company_size")}
                      border="var(--border)"
                    />
                    {errors.company_size && (
                      <ValidationErrorText
                        text={`${t("company_size")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col> */}
                <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("company_size")}*
                    </LabelStyled>
                    <SelectionDropdown
                      name={"company_size"}
                      value={watch("company_size")}
                      register={register}
                      errors={errors}
                      validationRules={{
                        required: true,
                      }}
                      options={localizedCompanySizeOptions}
                      placeholder={t("select_one")}
                      border="var(--border)"
                    />
                    {errors.company_size && (
                      <ValidationErrorText
                        text={`${t("company_size")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col>

                <Col lg={6} md={12}>
                  <PhoneInputField
                    name="phone_number"
                    label={"phone_number"}
                    placeholder={"phonePlaceholder"}
                    register={register}
                    control={control}
                    errors={errors}
                    staric={true}
                    validationRules={{
                      required: true,
                    }}
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                  />
                </Col>

                {/* <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("how_can_sales_team_help")}*
                    </LabelStyled>
                    <SecondaryInputStyled
                      {...register("help_type", {
                        required: true,
                      })}
                      placeholder={t("how_can_sales_team_help")}
                      border="var(--border)"
                    />
                    {errors.help_type && (
                      <ValidationErrorText
                        text={`${t("how_can_sales_team_help")} ${t(
                          "isRequired"
                        )}`}
                      />
                    )}
                  </Box>
                </Col> */}
                <Col lg={6} md={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("how_can_sales_team_help")}*
                    </LabelStyled>
                    <SelectionDropdown
                      name={"help_type"}
                      value={watch("help_type")}
                      register={register}
                      errors={errors}
                      validationRules={{
                        required: true,
                      }}
                      options={localizedSalesHelpOptions}
                      placeholder={t("select_one")}
                      border="var(--border)"
                    />
                    {errors.help_type && (
                      <ValidationErrorText
                        text={`${t("how_can_sales_team_help")} ${t(
                          "isRequired"
                        )}`}
                      />
                    )}
                  </Box>
                </Col>

                <Col lg={12}>
                  <Box className="field-box">
                    <LabelStyled color="var(--text)" size="16px" weight="700">
                      {t("anything_else")}
                    </LabelStyled>
                    <SecondaryTextAreaStyled
                      {...register("message", { required: false })}
                      placeholder={t("messagePlaceholder")}
                      border="var(--border)"
                    />
                    {errors.message && (
                      <ValidationErrorText
                        text={`${t("anything_else")} ${t("isRequired")}`}
                      />
                    )}
                  </Box>
                </Col>
              </Row>
            </Box>
          </Modal.Body>

          <Modal.Footer>
            <ButtonCustom
              label={t("cancel")}
              onClick={handleClose}
              type="button"
              bg="var(--bgSecondary)"
              color="var(--text2)"
            />
            <ButtonCustom
              label={t("submit")}
              onClick={handleSubmit(onSubmit)}
              bg="var(--themeColor)"
              color="var(--white)"
              isLoading={loading}
              disabled={loading}
            />
          </Modal.Footer>
        </Form>
      </Modal>
    </ModalWrapper>
  );
}

export default CustomModal;

const ModalWrapper = styled.div`
  .btn-close {
    margin: 0 !important;
  }
`;
